import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { geoData } from '@fs/zion-config'
import useCountries from './useCountries'
import useOnce from '../../../hooks/useOnce'

const initialState = {
  loading: true,
  countries: [],
  preferredCountry: null,
  setCountry: () => {},
}

const CountryContext = createContext()

export const useCountryContext = () => {
  const [state, setState] = useContext(CountryContext)
  const countryResponse = useCountries()

  const setCountry = useCallback(
    (overriddenCountry) => {
      setState((s) => ({ ...s, preferredCountry: overriddenCountry }))
    },
    [setState]
  )

  const onOnce = useOnce()
  useEffect(() => {
    if (!countryResponse.loading) {
      onOnce(() => {
        const preferredCountry =
          // If we override it before the response resolves
          state.preferredCountry ||
          countryResponse.countries.find(({ countryCode }) => countryCode === geoData.country)?.countryCode
        setState({ ...countryResponse, preferredCountry, setCountry })
      })
    }
  }, [countryResponse, onOnce, setCountry, setState, state.preferredCountry])

  return state
}

export const CountryProvider = ({ children }) => {
  const state = useState(initialState)

  const value = useMemo(() => state, [state])
  return <CountryContext.Provider value={value}>{children}</CountryContext.Provider>
}
